/**
 * SVG
 *
 * Import and appending of custom SVGs
 *
 * How to use:
 * - Make sure the SVG file is imported below
 * - Add the SVG to the Library
 * - Add the following classes to your component:
 *
 *    '.svg .svg--content-<customSvgName>'
 *
 */

// TODO allow rendering of additional SVGs after the initial render

class CustomSVG {
    constructor() {
        this.config = {
            prefix: 'svg--content',
            renderedClass: 'svg--rendered',
        };
        this.selector = '';
        this.library = {};
    }
    
    /**
     * Search for matching classes
     */
    init() {
        this.selector = this.config.prefix + '-';
        const querySelectorClass = '[class*=' + this.selector + ']:not(.' + this.config.renderedClass + ')';
        const svgContainers = document.querySelectorAll(querySelectorClass);
        // svgContainers.forEach(el => this.render(el));
        for (let i = 0; i < svgContainers.length; i += 1) {
            this.render(svgContainers[i]);
        }
    }
    
    /**
     * Append the SVG element
     */
    render(el) {
        const svg = this.getSVG(el);
        if (svg) {
            el.appendChild(svg);
            if (!el.classList.contains(this.config.renderedClass)) {
                el.classList.add(this.config.renderedClass);
            }
        }
    }
    
    /**
     * Fetch SVG file content from library and return DOM element
     */
    getSVG(el) {
        const className = el.className.match(this.regex())[0].replace(this.selector, '');
        try {
            const svgElement = this.library[this.constructor.toCamel(className)];
            return this.constructor.template(svgElement.trim());
        } catch (error) {
            console.error(error);
            return false;
        }
    }
    
    /**
     * Custom regex
     */
    regex() {
        return new RegExp(this.config.prefix + '-[^\\s]*');
    }
    
    /**
     * IE polyfill template
     */
    static template(svgElement) {
        const template = document.createElement('template');
        template.innerHTML = svgElement;
        if ('content' in template) return document.importNode(template.content, true);
        const fragment = document.createDocumentFragment();
        const children = template.childNodes;

        for (let i = 0; i < children.length; i += 1) {
            fragment.appendChild(children[i].cloneNode(true));
        }

        return fragment;
    }
    
    /**
     * hyphen-separated to camelCase
     */
    static toCamel(s) {
        return s.replace(/(-\w)/g, m => m[1].toUpperCase());
    }
}

const customSvg = new CustomSVG();
if (!window.customSvg) window.customSvg = customSvg;
export default customSvg;
